export default __webpack_public_path__ + "01dcbad1bac635f9c9cd6154e420baa8.woff2";